// src/constants/postActionDestinations.js

export const POST_ACTION_DESTINATIONS = {
  profile_banners: {
    key: 'profile_banners',
    title: 'Profile Banners',
    route: '/profile/banners',
  },

  plans: {
    key: 'plans',
    title: 'Plans',
    route: '/plans',
  },

  marketplace: {
    key: 'marketplace',
    title: 'Marketplace',
    route: '/marketplace',
  },

  pi_apps: {
    key: 'pi_apps',
    title: 'Pi Apps',
    route: '/pi-apps',
  },

  discover_people: {
    key: 'discover_people',
    title: 'Discover People',
    route: '/discover-people',
  },

  escrow: {
    key: 'escrow',
    title: 'BarterFi Escrow',
    route: '/escrow',
  },

  badges_leaderboard: {
    key: 'badges_leaderboard',
    title: 'Badges Leaderboard',
    route: '/badges-leaderboard',
  },

  feedback: {
    key: 'feedback',
    title: 'Feedback',
    route: '/feedback',
  },

  about_barterfi: {
    key: 'about_barterfi',
    title: 'About BarterFi',
    route: '/about-barterfi',
  },
};

export const POST_ACTION_DESTINATION_OPTIONS = Object.values(
  POST_ACTION_DESTINATIONS
);

export const getPostActionDestination = (destinationKey) => {
  if (!destinationKey || typeof destinationKey !== 'string') {
    return null;
  }

  return POST_ACTION_DESTINATIONS[destinationKey] || null;
};
